import script from "./ChangeExistingPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeExistingPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeExistingPassword.vue?vue&type=style&index=0&id=49981afe&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49981afe"]])

export default __exports__